import { render, staticRenderFns } from "./m-uploader.vue?vue&type=template&id=527cd4ee&scoped=true&"
import script from "./m-uploader.vue?vue&type=script&lang=js&"
export * from "./m-uploader.vue?vue&type=script&lang=js&"
import style0 from "./m-uploader.vue?vue&type=style&index=0&id=527cd4ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cd4ee",
  null
  
)

export default component.exports